//// Application Packages
import React from 'react'
import parse from 'html-react-parser'

//// Application Slices

//// Application Components

//// Carbon Components
import { Modal } from '@carbon/react'

//// Carbon Icons

//// Static Constants

//////// Component
const ModalComponent = ({
    modal: {
        size,
        alert,
        scroll,
        around_close,
        label,
        heading,
        paragraph,
        submit_label,
        close_label,
    },
    open,
    handleModalClose,
    handleModalSubmit,
}) => {
    //////// Hooks

    //////// State

    //////// Slices

    //// Slice Data

    //////// Search Params

    //////// Methods

    // Modal Style Object
    const mdlStyObj = {}

    // Modal Style - Size
    if (size) {
        mdlStyObj.size = size
    } else {
        mdlStyObj.size = 'lg'
    }

    // Modal Style - Alert
    if (alert) {
        mdlStyObj.alert = true
    } else {
        mdlStyObj.alert = false
    }

    // Modal Style - Scroll
    if (scroll) {
        mdlStyObj.scroll = true
    } else {
        mdlStyObj.scroll = false
    }

    // Modal Style - Around Close
    if (around_close) {
        mdlStyObj.around_close = true
    } else {
        mdlStyObj.around_close = false
    }

    // Modal Style - Label
    if (label) {
        mdlStyObj.label = label
    } else {
        mdlStyObj.label = ''
    }

    // Modal Style - Primary Button Label
    if (submit_label) {
        mdlStyObj.submit_label = submit_label
    } else {
        mdlStyObj.submit_label = 'Submit'
    }

    // Modal Style - Secondary Button Label
    if (close_label) {
        mdlStyObj.cancel_label = close_label
    } else {
        mdlStyObj.cancel_label = 'Cancel'
    }

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    if (heading && paragraph) {
        // Parse HTML String (Paragraph)
        const p = parse(`${paragraph}`)

        return (
            <>
                <div className="fldoh-modal-group">
                    <Modal
                        className="fldoh-modal"
                        open={open}
                        size={mdlStyObj.size}
                        modalLabel={mdlStyObj.label}
                        modalHeading={heading}
                        primaryButtonText={mdlStyObj.submit_label}
                        secondaryButtonText={mdlStyObj.cancel_label}
                        alert={mdlStyObj.alert}
                        hasScrollingContent={mdlStyObj.scroll}
                        preventCloseOnClickOutside={mdlStyObj.around_close}
                        onRequestSubmit={() => handleModalSubmit()}
                        onRequestClose={() => handleModalClose()}
                        data-testid="modal-component"
                    >
                        <p> {p} </p>
                    </Modal>
                </div>
            </>
        )
    } else {
        return <></>
    }
}

export default ModalComponent
